import { SociometrySessionStatus } from "shared/types/sociometry";

export interface StatusMeta {
    label: string;
    color: string;
}

export const sociometrySessionStatusMap: Record<SociometrySessionStatus, StatusMeta> = {
    Pending: { label: "Назначено", color: "#ffd144" },
    Active: { label: "В процессе", color: "#8ebe6e" },
    Completed: { label: "Завершено", color: "#0f14454d" },
};

export const getSociometrySessionStatusMeta = (status?: SociometrySessionStatus): StatusMeta => {
    if (!status) return sociometrySessionStatusMap.Pending;
    return sociometrySessionStatusMap[status];
};
